import { FormBuilder, Validators } from '@angular/forms';
import { MatSort, MatPaginator } from '@angular/material';
import { ObservableMedia } from '@angular/flex-layout';
import { first } from 'rxjs/operators/first';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { format, isBefore, isDate, parse } from 'date-fns';
import { DataTableSource } from '../../classes/DataTableSource/datatablesource';
import { ApplicationService } from '../../services/application/application.service';
import { AuthService } from '../../services/authentication/auth.service';
import { DialogService } from '../../services/dialogs/dialogs.service';
import { DownloadService } from '../../services/download/download.service';
import { ErrorService } from '../../services/error/error.service';
import { SplashService } from '../../services/splash/splash.service';
import { UserService } from '../../services/user/user.service';
import { DateFnsPipe } from '../../pipes/datefns.pipe';
import { TitleCasePipe } from '../../pipes/titlecase.pipe';
import { validateDate } from '../../validators/date.validator';
var IssueAlertComponent = /** @class */ (function () {
    function IssueAlertComponent(appService, authService, dateFNSPipe, dialogService, downloadService, errorService, fb, mediaChange, splashService, titleCasePipe, userService) {
        this.appService = appService;
        this.authService = authService;
        this.dateFNSPipe = dateFNSPipe;
        this.dialogService = dialogService;
        this.downloadService = downloadService;
        this.errorService = errorService;
        this.fb = fb;
        this.mediaChange = mediaChange;
        this.splashService = splashService;
        this.titleCasePipe = titleCasePipe;
        this.userService = userService;
        this._subrelease = new Subject();
        this.AllHeaders = [
            'IssueAlertNumber',
            'AlertMessage',
            'DateBegin',
            'DateEnd',
            'InEffect',
            'AddedBy',
            'LastUpdated',
            'Actions',
        ];
    }
    IssueAlertComponent.prototype.ngOnInit = function () {
        var self = this;
        self.FilteredAlertsList = null;
        self.AlertsDisplayMode = 'A';
        self.AlertsData = new DataTableSource([], self.paginator, self.sorter, self.SortAlerts.bind(self));
        self.AlertsList = null;
        self.InEffectCount = 0;
        self.NoData = false;
        self.ViewReady = false;
        self.ShowingNewAlertForm = false;
        self.SmallDisplay = false;
        self.User = null;
        self.SmallDisplay = self.mediaChange.isActive('xs') || self.mediaChange.isActive('sm');
        self.mediaChange
            .asObservable()
            .pipe(takeUntil(self._subrelease))
            .subscribe(function (media) {
            self.SmallDisplay = media.mqAlias === 'xs' || media.mqAlias === 'sm';
            self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
            self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
        });
        // Get the first non-null UserInfo object so we can begin setting up the component
        self.userService.UserSubject.pipe(takeUntil(self._subrelease), first(function (user) { return user && !!user.AuthToken; })).subscribe(function (user) {
            self.User = user;
            // Set up constant monitoring of the user object, to catch AuthToken updates.
            self.userService.UserSubject.pipe(takeUntil(self._subrelease)).subscribe(function (_user) {
                self.User = _user;
            });
            // Load the issue alerts in the database
            self.appService.GetAllWebAppIssueAlerts().subscribe(function (alerts) {
                self.UpdateAlerts(alerts);
                // Make the form for creating new alerts
                self.NewAlertForm = self.fb.group({
                    WebAppIssueAlertID: [null],
                    AlertMessage: [null, Validators.required],
                    DateBegin: [null, [Validators.required, validateDate]],
                    DateEnd: [null, [Validators.required, validateDate]],
                    IsUpdate: [false],
                });
                // Ready for component use.
                self.ViewReady = true;
            }, function (error) {
                self.errorService.HandleServiceError(error);
            });
        });
    };
    IssueAlertComponent.prototype.ngOnDestroy = function () {
        this._subrelease.next();
        this._subrelease.complete();
    };
    // #region Add New Alert Method
    IssueAlertComponent.prototype.AddNewAlert = function () {
        var self = this;
        var form = self.NewAlertForm.value;
        // Get confirmation
        self.dialogService
            .OpenConfirmationDialog({
            TitleText: 'Confirmation Requested',
            MessageText: "You are about to add the following new issue alert:<br /><br />" +
                ("<strong>Alert Message: </strong><br /><em>" + form.AlertMessage + "</em><br />") +
                ("<strong>Display Begin Date: </strong>" + self.dateFNSPipe.transform(form.DateBegin, 'M/D/YYYY h:mm A') + "<br />") +
                ("<strong>Display End Date: </strong>" + self.dateFNSPipe.transform(form.DateEnd, 'M/D/YYYY h:mm A') + "<br /><br />") +
                "Once added, the new issue alert will be broadcast on the login screen and the Issue Reporting Tool " +
                "during the window in which it is set to be in effect. Are you sure you wish to add this issue alert?",
            OKText: 'Yes - Add',
            CancelText: 'No - Cancel',
        })
            .subscribe(function (result) {
            if (result === true) {
                // User is proceeding. Add the new issue alert.
                var dbegin = parse(form.DateBegin);
                var dend = parse(form.DateEnd);
                self.appService
                    .AddWebAppIssueAlert(self.User.AuthToken, self.User.CurrentRole, form.AlertMessage, dbegin, dend)
                    .subscribe(function (alerts) {
                    // Update the alerts.
                    self.UpdateAlerts(alerts);
                    // Clear the new issue alert form.
                    self.NewAlertForm.reset();
                    // Snackbar success
                    self.splashService.SnackbarSuccess('Issue Alert Added Successfully.');
                }, function (error) {
                    self.errorService.HandleServiceError(error);
                });
            }
        });
    };
    // #endregion
    // #region Disable Alert Method
    IssueAlertComponent.prototype.DisableAlert = function (alert) {
        var self = this;
        if (!alert) {
            return;
        }
        self.dialogService
            .OpenConfirmationDialog({
            TitleText: 'Confirmation Requested',
            MessageText: "You are about to disable the following issue alert in the DELTA System:<br /><br />" +
                ("<strong>Issue Alert ID #: </strong>" + alert.WebAppIssueAlertID + "<br />") +
                ("<strong>Alert Message: </strong><br /><em>" + alert.AlertMessage + "</em><br />") +
                ("<strong>Display Begin Date: </strong>" + self.dateFNSPipe.transform(alert.DateBegin, 'M/D/YYYY h:mm A') + "<br />") +
                ("<strong>Display End Date: </strong>" + self.dateFNSPipe.transform(alert.DateEnd, 'M/D/YYYY h:mm A') + "<br /><br />") +
                ("<strong>Last Modified By: </strong>" + self.titleCasePipe.transform(alert.AddedByFirstName) + " ") +
                (self.titleCasePipe.transform(alert.AddedByLastName) + " (SAPID " + alert.AddedBySAPID + ")<br />") +
                ("<strong>Last Modified On: </strong>" + self.dateFNSPipe.transform(alert.LastUpdated, 'M/D/YYYY h:mm A') + "<br /><br />") +
                "Once disabled, this issue alert will no longer be displayed in the DELTA System but will not be " +
                "removed from the system, in case you wish to reactivate it later. Are you sure you wish to continue?",
            OKText: 'Yes - Disable',
            CancelText: 'No - Cancel',
        })
            .subscribe(function (result) {
            if (result === true) {
                // Disable the alert by setting the end date to the start date
                self.appService
                    .UpdateWebAppIssueAlert(self.User.AuthToken, self.User.CurrentRole, alert.WebAppIssueAlertID, alert.AlertMessage, alert.DateBegin, alert.DateBegin)
                    .subscribe(function (alerts) {
                    // Update the alerts.
                    self.UpdateAlerts(alerts);
                    // Clear the new issue alert form.
                    self.NewAlertForm.reset();
                    // Snackbar success
                    self.splashService.SnackbarSuccess('Issue Alert Disabled Successfully.');
                }, function (error) {
                    self.errorService.HandleServiceError(error);
                });
            }
        });
    };
    // #endregion
    // #region Load Update Form Method
    IssueAlertComponent.prototype.LoadUpdateForm = function (alert) {
        var self = this;
        if (!alert) {
            return;
        }
        // Patch the form with the values passed in
        var patch = {
            WebAppIssueAlertID: alert.WebAppIssueAlertID,
            AlertMessage: alert.AlertMessage,
            DateBegin: format(alert.DateBegin, 'M/D/YYYY h:mm A'),
            DateEnd: format(alert.DateEnd, 'M/D/YYYY h:mm A'),
            IsUpdate: true,
        };
        self.NewAlertForm.patchValue(patch);
    };
    // #endregion
    // #region Remove Alert Method
    IssueAlertComponent.prototype.RemoveAlert = function (alert) {
        var self = this;
        if (!alert) {
            return;
        }
        self.dialogService
            .OpenConfirmationDialog({
            TitleText: 'Confirmation Requested',
            MessageText: "You are about to remove the following issue alert from the DELTA System:<br /><br />\n        <strong>Issue Alert ID #: </strong>" + alert.WebAppIssueAlertID + "<br />\n        <strong>Alert Message: </strong><br />\n        <em>" + alert.AlertMessage + "</em><br />\n        <strong>Display Begin Date: </strong>" + self.dateFNSPipe.transform(alert.DateBegin, 'M/D/YYYY h:mm A') + "<br />\n        <strong>Display End Date: </strong>" + self.dateFNSPipe.transform(alert.DateEnd, 'M/D/YYYY h:mm A') + "<br /><br />\n        <strong>Last Modified By: </strong>" + self.titleCasePipe.transform(alert.AddedByFirstName) + " " + self.titleCasePipe.transform(alert.AddedByLastName) + " (SAPID " + alert.AddedBySAPID + ")<br />\n        <strong>Last Modified On: </strong>" + self.dateFNSPipe.transform(alert.LastUpdated, 'M/D/YYYY h:mm A') + "<br /><br />\n        Once removed, this issue alert will no longer be displayed in the DELTA System. Are you sure you wish to continue?",
            OKText: 'Yes - Remove',
            CancelText: 'No - Cancel',
        })
            .subscribe(function (result) {
            if (result === true) {
                // Remove the alert
                self.appService
                    .RemoveWebAppIssueAlert(self.User.AuthToken, self.User.CurrentRole, alert.WebAppIssueAlertID)
                    .subscribe(function (alerts) {
                    // Update the alerts.
                    self.UpdateAlerts(alerts);
                    // Snackbar success
                    self.splashService.SnackbarSuccess('Issue Alert Removed Successfully.');
                }, function (error) {
                    self.errorService.HandleServiceError(error);
                });
            }
        });
    };
    // #endregion
    // #region Sort Alerts Method
    IssueAlertComponent.prototype.SortAlerts = function (First, Second) {
        var self = this;
        var PropA;
        var PropB;
        switch (self.sorter.active) {
            case 'IssueAlertNumber':
                _a = [First.WebAppIssueAlertID, Second.WebAppIssueAlertID], PropA = _a[0], PropB = _a[1];
                break;
            case 'AlertMessage':
                _b = [First.AlertMessage, Second.AlertMessage], PropA = _b[0], PropB = _b[1];
                break;
            case 'DateBegin':
                _c = [First.DateBegin, Second.DateBegin], PropA = _c[0], PropB = _c[1];
                break;
            case 'DateEnd':
                _d = [First.DateEnd, Second.DateEnd], PropA = _d[0], PropB = _d[1];
                break;
            case 'InEffect':
                _e = [First.InEffect ? 'Yes' : 'No', Second.InEffect ? 'Yes' : 'No'], PropA = _e[0], PropB = _e[1];
                break;
            case 'AddedBy':
                _f = [
                    First.AddedByLastName + ", " + First.AddedByFirstName,
                    Second.AddedByLastName + ", " + Second.AddedByFirstName,
                ], PropA = _f[0], PropB = _f[1];
                break;
            case 'LastUpdated':
                _g = [First.LastUpdated, Second.LastUpdated], PropA = _g[0], PropB = _g[1];
                break;
        }
        if (isDate(PropA) || isDate(PropB)) {
            var baseSort = 0;
            if (isDate(PropA) && !isDate(PropB)) {
                baseSort = 1;
            }
            else if (isDate(PropB) && !isDate(PropA)) {
                baseSort = -1;
            }
            else if (isBefore(PropA, PropB)) {
                baseSort = -1;
            }
            else if (isBefore(PropB, PropA)) {
                baseSort = 1;
            }
            return baseSort * (self.sorter.direction === 'asc' ? 1 : -1);
        }
        else {
            var ValueA = PropA != null && PropA !== '' ? (isNaN(+PropA) ? PropA : +PropA) : PropA;
            var ValueB = PropB != null && PropB !== '' ? (isNaN(+PropB) ? PropB : +PropB) : PropB;
            return (ValueA < ValueB ? -1 : 1) * (self.sorter.direction === 'asc' ? 1 : -1);
        }
        var _a, _b, _c, _d, _e, _f, _g;
    };
    // #endregion
    // #region Update Alert Display Mode Method
    IssueAlertComponent.prototype.UpdateAlertDisplayMode = function (event) {
        var self = this;
        if (!event || !event.value) {
            return;
        }
        // Update the alerts by triggering the filtering
        self.UpdateAlerts(self.AlertsList);
    };
    // #endregion
    // #region Update Alerts Method
    IssueAlertComponent.prototype.UpdateAlerts = function (alerts) {
        var self = this;
        self.AlertsList = alerts;
        self.InEffectCount = (alerts || []).filter(function (item) { return item.InEffect === true; }).length || 0;
        // Apply filtering.
        self.FilteredAlertsList = (self.AlertsList || []).filter(function (item) {
            return (self.AlertsDisplayMode === 'A' ||
                (self.AlertsDisplayMode === 'I' && item.InEffect === true) ||
                (self.AlertsDisplayMode === 'X' && item.InEffect !== true));
        });
        if (!self.FilteredAlertsList || !self.FilteredAlertsList.length) {
            self.NoData = true;
            // Put in a fake record to trip the display message
            self.AlertsData.Update([{}]);
        }
        else {
            self.NoData = false;
            self.AlertsData.Update(self.FilteredAlertsList);
        }
        self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
        self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
    };
    // #endregion
    // #region Update Existing Alert Method
    IssueAlertComponent.prototype.UpdateExistingAlert = function () {
        var self = this;
        var form = self.NewAlertForm.value;
        // Get confirmation
        self.dialogService
            .OpenConfirmationDialog({
            TitleText: 'Confirmation Requested',
            MessageText: "You are about to update Alert #" + form.WebAppIssueAlertID + " to the following new :<br /><br />" +
                ("<strong>Alert Message: </strong><br /><em>" + form.AlertMessage + "</em><br />") +
                ("<strong>Display Begin Date: </strong>" + self.dateFNSPipe.transform(form.DateBegin, 'M/D/YYYY h:mm A') + "<br />") +
                ("<strong>Display End Date: </strong>" + self.dateFNSPipe.transform(form.DateEnd, 'M/D/YYYY h:mm A') + "<br /><br />") +
                "Once updated, the issue alert will be broadcast on the login screen and the Issue Reporting Tool " +
                "(if appropriate) during the window in which it is set to be in effect. Are you sure you wish to update this " +
                "issue alert?",
            OKText: 'Yes - Update',
            CancelText: 'No - Cancel',
        })
            .subscribe(function (result) {
            if (result === true) {
                // User is proceeding. Update the issue alert.
                var dbegin = parse(form.DateBegin);
                var dend = parse(form.DateEnd);
                self.appService
                    .UpdateWebAppIssueAlert(self.User.AuthToken, self.User.CurrentRole, form.WebAppIssueAlertID, form.AlertMessage, dbegin, dend)
                    .subscribe(function (alerts) {
                    // Update the alerts.
                    self.UpdateAlerts(alerts);
                    // Clear the new issue alert form.
                    self.NewAlertForm.reset();
                    // Snackbar success
                    self.splashService.SnackbarSuccess('Issue Alert Updated Successfully.');
                }, function (error) {
                    self.errorService.HandleServiceError(error);
                });
            }
        });
    };
    return IssueAlertComponent;
}());
export { IssueAlertComponent };
// #region Custom Classes
// #endregion



// WEBPACK FOOTER //
// ./src/app/issuealert/issuealert.component.ts.pre-build-optimizer.js